import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import img2 from "../../../assets/simmetry/landingImage.jpg";
import img4 from "../../../assets/simmetry/landingImg4.jpg";
import { useNavigate } from "react-router-dom";
import { postLogDetails } from "../../../Services/APIs/appDetails";
import { checkForSimulationUid } from "../../../Services/APIs/scan";

const LandingPageWithUID = () => {
    const navigate = useNavigate();
    const { uid, company } = useSelector(state => state.smileWhite);
    const hasUid = Boolean(uid);
    const [isLoadingUidDetails, setIsLoadingUidDetails] = useState(false);
    const [folderExists, setFolderExists] = useState(false);
    const [folderCheckComplete, setFolderCheckComplete] = useState(false);

    const takeScan = () => {
        if (!hasUid) {
            alert("Uid is required for a scan");
            return;
        }
        if (folderExists) {
            alert("The Scan with UID already exists");
            return;
        }
        navigate(`/smilewhite/scan`);
    };

    // Effect to fetch UID details when UID becomes available
    useEffect(() => {
        const getUidDetails = async () => {
            if (!uid) {
                setFolderCheckComplete(true);
                return;
            }

            setIsLoadingUidDetails(true);
            setFolderCheckComplete(false);
            
            try {
                const response = await checkForSimulationUid({ 
                    uid, 
                    company: "smilewhite" 
                });
                                
                // Check if folder exists
                const apiResult = response.data.data;
                if (apiResult && typeof apiResult.exists === 'boolean') {
                    setFolderExists(apiResult.exists);
                } else {
                    setFolderExists(false);
                }
                
            } catch (error) {
                setFolderExists(false); // Default to false on error
            } finally {
                setIsLoadingUidDetails(false);
                setFolderCheckComplete(true);
            }
        };

        getUidDetails();
    }, [uid]); // Run when uid changes

    // Effect to log page visit when UID is available
    useEffect(() => {
        if (uid && company) {
            try {
                postLogDetails({
                    app: "Smile-white",
                    payLoad: "visited landing page and started",
                    uid: uid
                });
            } catch (error) {
                console.error("Error logging page visit:", error);
            }
        }
    }, [uid, company]); // Run when uid or company changes

    // Determine button state
    const shouldDisableButton = !hasUid || isLoadingUidDetails || folderExists;
    const buttonText = isLoadingUidDetails ? 'Checking...' : 'Transform Your Smile';

    return (
        <div className="bg-white w-full h-full flex flex-col">
            <div className="h-1/3 relative w-full flex justify-start items-start">
                <img src={img2} alt="ai-teeth" className="h-full w-full absolute right-0 object-cover" />
            </div>
            {/* <div className="w-full bg-black -mt-8 relative">
                <img src={img4} alt="background-design" className="h-36 sm600:h-52 absolute right-0" />
            </div> */}
            <div className="flex-grow flex flex-col py-8 justify-start">
                <div className="ml-8 py-8">
                    <p className="font-red-hat font-medium text-3xl py-2 text-[#022022]">
                        Virtual smile <br /> simulator
                    </p>

                    <p className="py-2 first-letter:font-red-hat text-[#8B8A97] text-xl">
                        Smile, snap a selfie, and see <br /> the magic!
                    </p>
                </div>

                <div className="mt-2 w-full px-8 text-center pb-20 sm600:pb-0">
                    {/* Error messages */}
                    {!hasUid && (
                        <p className="text-red-500 text-sm mt-2">
                            UID parameter is required
                        </p>
                    )}
                    {hasUid && folderCheckComplete && folderExists && (
                        <p className="text-red-500 text-sm mt-2">
                            The Scan with UID already exists
                        </p>
                    )}
                    {/* {hasUid && folderCheckComplete && !folderExists && (
                        <p className="text-green-600 text-sm mt-2">
                            Ready to scan
                        </p>
                    )} */}
                    <button
                        type="button"
                        className={`  w-11/12 max-w-md z-50 text-base font-red-hat h-12 rounded text-white universal-button sm600:text-2xl ${
                            shouldDisableButton ? 'opacity-75 cursor-not-allowed' : ''
                        }`}
                        style={{ backgroundColor: '#4378ff' }}
                        onClick={takeScan}
                        disabled={shouldDisableButton}
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LandingPageWithUID;